<template>
  <div>
    <router-link class="action" :class="{ 'premium': subscription_plan.premium }"
      :to="{ name: 'purchase.subscription', query: { plan: subscription_plan.id } }">

      <div class="description">
        <span v-if="!is_original_plan" class="left-button-description">
          {{ subscription_plan.subscription_plan_name }}
        </span>
        <span class="right-button-description">
          {{ subscription_plan.subscription_plan_detail }}
        </span>
      </div>
    </router-link>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    subscription_plan: {
      type: Object,
      required: true
    },
    is_original_plan_data: {
      type: Boolean,
    }
  },
  data() {
    return {
      is_original_plan:false
    };
  },
  mounted() {
    this.is_original_plan = this.is_original_plan_data;
  },
  methods: {
  },
}
</script>

<style scoped lang="scss">
@import '../../styles/variables';

.action {
  display: flex;
  height: 50px;
  text-align: center;
  background: #dedfe2;
  cursor: pointer;
  margin-bottom: 5px;
  overflow: hidden;
  font-weight: 600;
  border-radius: 45px;

  .icon {
    width: 80px;
    height: 50px;
    // background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-image: var(--img-btn-eye);
    background-color: var(--pallete_main_color);
  }

  .description {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
    background-color: var(--pallete_main_color);
    color: white;

    span:first-child {
      font-size: .9em;
    }

    small {
      font-size: .7em;
    }

    .left-button-description {
      text-align: left;
      padding-left: 5%;
      font-weight: bold;
      font-size: large !important;
    }

    .right-button-description {
      text-align: right;
      padding-right: 5%;
    }
  }

  &.premium {
    .icon {
      background-image: url("/img/btn/btn-premium.png");
    }

    .description {}
  }
}
</style>
